import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AgreementRef } from "./AgreementRef";
import type { AgreementStaff } from "./AgreementStaff";
import type { CatalogItemAgreementDTOBase } from "./CatalogItemAgreementDTOBase";
import type { CatalogItemRef } from "./CatalogItemRef";
import type { CatalogItemStaff } from "./CatalogItemStaff";

export class CatalogItemAgreementStaff implements CatalogItemAgreementDTOBase {
  constructor(public readonly assignId: number, public readonly itemId: CatalogItemStaff | null, public readonly agreementId: AgreementStaff | null, public readonly itemIdTargetIds: CatalogItemRef, public readonly agreementIdTargetIds: AgreementRef) {
    this.cbiServiceContext = null;
    this.itemIdLoaded = this.itemId != null;
    this.itemIdCached = this.itemId;
    this.agreementIdLoaded = this.agreementId != null;
    this.agreementIdCached = this.agreementId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemIdLoaded: boolean;
  private itemIdCached: CatalogItemStaff | null;
  private agreementIdLoaded: boolean;
  private agreementIdCached: AgreementStaff | null;
  async itemIdLazy(): Promise<CatalogItemStaff> {
    if (!this.itemIdLoaded) {
      this.itemIdCached = await this.cbiServiceContext!.catalogService().getCatalogItemStaff(this.itemIdTargetIds.assignId);
      this.itemIdLoaded = true;
    }
    return this.itemIdCached!;
  }
  async agreementIdLazy(): Promise<AgreementStaff> {
    if (!this.agreementIdLoaded) {
      this.agreementIdCached = await this.cbiServiceContext!.catalogService().getAgreementStaff(this.agreementIdTargetIds.assignId);
      this.agreementIdLoaded = true;
    }
    return this.agreementIdCached!;
  }
}
